var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graphicDesignDepartmentIcon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    height: "28px",
    fill: "#fff",
    stroke: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n      #graphicDesignDepartmentIcon {\r\n        .st0{fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n      .st1{fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;}\r\n      .st2{fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:6,6;}\r\n      .st3{fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:4,4;}\r\n      .st4{fill:none;stroke-width:1.6;stroke-linecap:round;}\r\n      .st5{fill:none;stroke-width:1.6;stroke-linecap:round;stroke-dasharray:3.1081,3.1081;}\r\n      .st6{fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:4,3;}} "), /*#__PURE__*/React.createElement("path", {
    id: "graphicDesignDepartmentIcon",
    className: "st0",
    d: "M4,17C4,10.4,9.4,5,16,5s12,5.4,12,12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16,
    className: "st0",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 16,
    className: "st0",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 4,
    className: "st0",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 4,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4,
    y1: 5,
    x2: 28,
    y2: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,10l-6,9.2c1.6,1.8,2.8,4.1,3.4,6.8H16h2.6c0.6-2.7,1.8-5.1,3.4-6.8L16,10z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 17,
    x2: 16,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 26,
    className: "st0",
    width: 6,
    height: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicDesign);
export default __webpack_public_path__ + "static/media/graphicDesign.2b1a57eb9f369ad77034aefef68e677f.svg";
export { ForwardRef as ReactComponent };